import React from 'react'
import './Footer.css';

function Footer() {
    const footerYear = new Date().getFullYear()

    return (
        <>
        <div className="footer_container">
        <p>© {footerYear} Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by Learning Experiences - L&TT, ATCI.</p>
        </div>
        </>
    )
}

export default Footer;
